import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names with conflict resolution.
 * Used by every shadcn/ui primitive (Design System v1, §7).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
